import { render, staticRenderFns } from "./channelManage.vue?vue&type=template&id=591efa47&scoped=true&"
import script from "./channelManage.vue?vue&type=script&lang=js&"
export * from "./channelManage.vue?vue&type=script&lang=js&"
import style0 from "./channelManage.vue?vue&type=style&index=0&id=591efa47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591efa47",
  null
  
)

export default component.exports